import { Component, OnInit, Input, OnChanges, SimpleChanges } from "@angular/core";
import { BaseModel, FormGeneratorService } from "@ngx-resource-toolkit/core";
import { FormGroup } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { ToasterService } from "angular2-toaster";
import { SettingsService } from "../../core/settings/settings.service";
import { ProfesseurModel } from "../../professeur/models/professeur.model";
import { DateHelper } from "../helpers/date.helper";
import * as moment from 'moment';
import { CoursModel } from "../../cours/models/cours.model";

@Component({
    selector: 'occupation-input',
    templateUrl: './occupation-input.component.html',
    styleUrls: ['occupation-input.component.scss']
})
export class OccupationInputComponent implements OnInit, OnChanges {

    @Input() professeur: ProfesseurModel;

    public DateHelper = DateHelper;

    constructor(
        private settings: SettingsService,
        private toaster: ToasterService,
        private http: HttpClient,
        private formGenerator: FormGeneratorService) {

    }

    ngOnInit(): void {

    }

    ngOnChanges(changes: SimpleChanges): void {
    }

    getWidth() {
        return this.professeur.heureContrat ?
            +this.professeur.heurePrevue <= +this.professeur.heureContrat ?
                {
                    filled: Math.floor((this.professeur.heurePrevue/this.professeur.heureContrat)*100) + '%',
                    overflow: '0%' //100 - Math.floor((this.professeur.heurePrevue/this.professeur.heureContrat)*100) + '%',
                } : {
                    filled: 100 - Math.floor((this.professeur.heurePrevue - this.professeur.heureContrat)*100/this.professeur.heureContrat) + '%',
                    overflow: Math.floor((this.professeur.heurePrevue - this.professeur.heureContrat)*100/this.professeur.heureContrat) + '%',
                }

            : {
                filled: 0,
                overflow: 100 + '%',
            }
    }

}


// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/occupation/occupation-input.component.ts